import React, { useState } from "react";
import { FormLayout, OverlayForm } from "playground/cms/Form";
import { ListLayout } from "playground/cms/List";
import Resources from "playground/cms/views/Resources";
import BuildingsForm from "./PlansForm";
import ListItem from "./ListItem";
import { Search } from "playground/cms/List/Filter";
import Filters from "./Filters";
import PlanEditor from "plan-editor";
import PlanEditorContext from "./PlanEditorContext";

//import PropTypes from 'prop-types';

export function Plans(props) {
    const { type } = props;

    const [planEditor, showPlanEditor] = useState();

    return (
        <PlanEditorContext.Provider value={showPlanEditor}>
            <Resources {...props} ListItem={ListItem}>
                <ListLayout>
                    <ListLayout.Filter>
                        <Search type={type} name={"search"} />
                        <Filters {...props} />
                    </ListLayout.Filter>
                    <ListLayout.Header>
                        <ListLayout.Header.Icons prepend={true}>
                            <ListLayout.Header.Filter />
                        </ListLayout.Header.Icons>
                    </ListLayout.Header>
                </ListLayout>
                <FormLayout>
                    <FormLayout.Content replace={true}>
                        <FormLayout.Tab id={"building"} label={"Budynek"}>
                            <BuildingsForm {...props} />
                        </FormLayout.Tab>
                    </FormLayout.Content>
                </FormLayout>
            </Resources>
            <OverlayForm
                open={planEditor}
                onClose={() => showPlanEditor(false)}
                width={"wide"}
            >
                {planEditor && (
                    <PlanEditor
                        type={"apartments.plans"}
                        onClose={() => showPlanEditor(false)}
                    />
                )}
            </OverlayForm>
        </PlanEditorContext.Provider>
    );
}

Plans.propTypes = {};

Plans.defaultProps = {};

export default Plans;
